export const heroData = {
  headline: "让安全无忧成为日常",
  subheadline: "安大师凭借多年行业经验，为家庭、企业与个人量身定制全方位安全防护方案",
  ctaText: "了解解决方案",
  ctaLink: "/category/family",
  secondaryCtaText: "咨询专家",
  secondaryCtaLink: "/about",
  stats: [
    { value: "15+", label: "年行业经验" },
    { value: "50,000+", label: "服务客户" },
    { value: "98.6%", label: "客户满意度" },
    { value: "200+", label: "专业团队" },
  ],
};

export const serviceCategories = [
  {
    id: "family",
    name: "家庭安全",
    description: "从智能门锁到全屋监控，为家人打造安全舒适的居住环境",
    icon: "ri-home-gear-line",
    features: ["智能门锁", "视频监控", "烟雾报警", "门窗防护", "智能联动"],
    imageSeq: "family-security",
    link: "/category/family",
  },
  {
    id: "business",
    name: "企业防护",
    description: "全方位企业安全解决方案，守护资产、数据与员工安全",
    icon: "ri-building-2-line",
    features: ["门禁系统", "安防巡逻", "数据安全", "消防系统", "风险管理"],
    imageSeq: "business-security",
    link: "/category/business",
  },
  {
    id: "personal",
    name: "个人保障",
    description: "个人安全防护装备与培训，让每个人都能保护好自己",
    icon: "ri-shield-user-line",
    features: ["防护装备", "安全培训", "应急工具", "定位追踪", "法律援助"],
    imageSeq: "personal-security",
    link: "/category/personal",
  },
];

export const features = [
  {
    id: 1,
    title: "量身定制方案",
    description: "每个客户需求不同，我们提供一对一专属定制服务，确保方案精准匹配您的实际情况",
    icon: "ri-custom-size",
  },
  {
    id: 2,
    title: "7×24小时响应",
    description: "全天候监控与应急响应团队，无论何时何地，第一时间为您解决问题",
    icon: "ri-24-hours-line",
  },
  {
    id: 3,
    title: "智能科技加持",
    description: "融合 AI 智能分析、物联网技术，让安全防护更加高效、精准、智能",
    icon: "ri-cpu-line",
  },
  {
    id: 4,
    title: "专业认证团队",
    description: "所有技术人员均持证上岗，定期培训考核，确保专业水准始终在线",
    icon: "ri-verified-badge-line",
  },
  {
    id: 5,
    title: "售后无忧保障",
    description: "完善的售后服务体系，设备质保、定期巡检、终身技术支持",
    icon: "ri-shield-check-line",
  },
  {
    id: 6,
    title: "数据安全保障",
    description: "严格的数据加密与隐私保护机制，您的信息安全是我们首要责任",
    icon: "ri-lock-password-line",
  },
];

export const testimonials = [
  {
    id: 1,
    name: "张建国",
    role: "某小区业主委员会主任",
    content: "自从小区安装了安大师的全套安防系统后，盗窃案件下降了90%以上。居民们晚上终于可以安心睡觉了。安大师的专业团队从方案设计到施工验收，每个环节都让人放心。",
    rating: 5,
    location: "北京朝阳区",
  },
  {
    id: 2,
    name: "李明华",
    role: "华泰科技集团行政总监",
    content: "作为一家拥有3000名员工的科技企业，数据安全是我们的生命线。安大师为企业量身定制的综合安防方案，完美解决了我们的门禁管理、访客系统和数据保护需求。合作三年，从未出过任何问题。",
    rating: 5,
    location: "深圳南山区",
  },
  {
    id: 3,
    name: "王晓芳",
    role: "独居女性",
    content: "一个人住在城市里，安全一直是我最担心的事。安大师的个人安全套餐真的帮了大忙，智能门磁、随身报警器和24小时响应，让我终于有了安全感。特别推荐给独居的姐妹们！",
    rating: 5,
    location: "上海浦东新区",
  },
  {
    id: 4,
    name: "赵志强",
    role: "连锁餐饮品牌创始人",
    content: "旗下32家门店全部采用安大师的企业防护方案。消防系统、厨房安全监控、夜间防盗，一站式解决。最让我满意的是他们的应急响应速度，真的做到了分秒必争。",
    rating: 5,
    location: "广州天河区",
  },
];

export const faqData = [
  {
    id: 1,
    question: "安大师的服务覆盖哪些地区？",
    answer: "安大师目前服务覆盖全国主要一、二线城市，包括北京、上海、广州、深圳、杭州、成都等30余座城市。对于其他地区，我们也提供远程技术咨询和方案设计服务。",
  },
  {
    id: 2,
    question: "安装安防系统需要多长时间？",
    answer: "家庭方案通常1-2天即可完成安装调试；企业方案根据规模大小，一般在3-7个工作日内完成。我们会提前与您预约时间，尽量减少对您日常生活和工作的影响。",
  },
  {
    id: 3,
    question: "系统出现故障怎么办？",
    answer: "我们提供7×24小时技术支持热线，小问题远程指导解决，重大问题工程师2小时内上门。所有设备均享受质保服务，故障期间免费提供备机，确保您的安全防护不中断。",
  },
  {
    id: 4,
    question: "安大师的收费方式是怎样的？",
    answer: "我们提供灵活的收费方案：可以选择设备购买+安装服务的一次性付费，也可以选择按月付费的安全托管服务。具体费用根据您的需求定制方案后报价，确保透明合理，无隐形消费。",
  },
  {
    id: 5,
    question: "如何开始使用安大师的服务？",
    answer: "您可以通过官网预约免费上门评估，我们的安全顾问会实地勘察后为您定制方案。也可以直接拨打服务热线 400-888-9999，我们的客服团队会为您安排一切。",
  },
];